import { render, staticRenderFns } from "./InventionDocuments.vue?vue&type=template&id=7622d275&scoped=true&"
import script from "./InventionDocuments.vue?vue&type=script&lang=js&"
export * from "./InventionDocuments.vue?vue&type=script&lang=js&"
import style0 from "./InventionDocuments.vue?vue&type=style&index=0&id=7622d275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7622d275",
  null
  
)

export default component.exports